/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useState, useEffect } from "react";
import { useTheme } from "@material-ui/core/styles";
import { GblContext } from "providers/formatter";
import { useStateWithCallbackLazy } from "use-state-with-callback";
import { makeStyles } from "@material-ui/core/styles";
import {
  Hidden,
  Box,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  Typography,
  CircularProgress,
} from "@material-ui/core";
import {
  delWhtReconcileDetail,
  updateWhtReconcileDetail,
  createWhtReconcileDetail,
  getWhtReconcileByYearMonth,
  getWhtYearList,
  importWhtYearList,
} from "services/reconcile";
import { getApVendorList, getApWhtTypeSearchList, getApWhtServiceSearchList } from "services/accountPayable";
import { callStoreReport, postApWhtReconExpSp } from "services/callStoreProcedure";
import { showReportByName } from "pages/Report/services";
import { TableHead, TableRow, TableCell, Tooltip, Icon, IconButton } from "@material-ui/core";
import { MTableHeader, MTableToolbar } from "material-table";
import MeterialtableTranslate from "components/MeterialtableTranslate";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Dialog from "@material-ui/core/Dialog";
import ActionMenu from "components/ActionMenu";
import PopupTable from "components/PopupTable";
import { TextFieldInForm, DateInForm, NumberFormatInForm, MuiAutosuggest, SelectInForm } from "components/Form";
import Model from "models/whtReconcile";
import DialogOptions from "./DialogOptions";
import DialogPrintItem from "./DialogPrintOptions";
import { WithholdingTaxRefOption } from "utils/options";
import { getMonth, getYear, lastDayOfMonth } from "date-fns";
import SnackbarUtils from "utils/SnackbarUtils";
import * as XLSX from "xlsx";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  rootTitle: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  divComment: {
    position: "relative",
    height: "20px",
    width: "140px",
  },
  parentStyle: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    boxSizing: "border-box",
    display: "block",
    width: "100%",
  },
  cellStyleEllipsis: {
    boxSizing: "border-box",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
}));

const DialogWhtRec = (props) => {
  const theme = useTheme();
  const classes = useStyles();
  const { settingAll, DateToString, NumberFormat, ToNumber, ToMySqlDate, GetSettingCountry } = useContext(GblContext);
  const { SettingSystem } = settingAll;
  const { onClose, open, translate } = props;
  const [initNewRow, setInitNewRow] = useStateWithCallbackLazy(Model);
  const [showAdd, setShowAdd] = useState(false);
  const [editIndex, setEditIndex] = useState("");
  const [checkSource, setCheckSource] = useState(false);
  const [Data, setData] = useState();
  const [listId, setListId] = useState([]);
  const listOfMonth = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
  const [listOfWhtYear, setListOfWhtYear] = useState();
  const [lookupList, setLookupList] = useState({
    vendorList: [],
    whtTypeList: [],
    whtServiceList: [],
  });
  let m = new Date().getMonth() + 1;
  const [filter, setFilter] = useState({
    month: m < 10 ? "0" + m : m,
    year: new Date().getFullYear(),
    whtForm: "All",
  });

  const [openDialog, setOpenDialog] = useState({
    form: false,
    report: false,
    export: false,
  });
  const [isLoading, setLoading] = useState(true);
  const [isLoadingBtn, setLoadingBtn] = useState(false);
  const menuControlProp = [
    {
      name: "Print Form",
      fnc: () => setOpenDialog((state) => ({ ...state, form: true })),
      disabled: listId?.length < 1,
      hide: GetSettingCountry().hideWhtReconBtnPrint,
    },
    {
      name: "Print Report",
      fnc: async () => {
        if (GetSettingCountry().useCustomWhtReport) {
          let period = `${filter.year}-${filter.month}`;
          let id = listId.length > 0 ? listId.join() : "";
          //let page = "";
          let param = [
            { Name: "Period", Value: period },
            { Name: "SeqId", Value: id },
            { Name: "TaxType", Value: "" },
          ];
          setLoadingBtn(true);
          let status = await showReportByName(GetSettingCountry().whtReconReportName, param);
          if (status) {
            setLoadingBtn(false);
          }
        } else {
          setOpenDialog((state) => ({ ...state, report: true }));
        }
      },
      disabled: GetSettingCountry().hideWhtReconBtnPrint ? listId?.length < 1 : Data?.length < 1,
    },
    {
      name: "Export",
      fnc: async () => {
        let period = `${filter.year}-${filter.month}`;
        let id = listId.length > 0 ? listId.join() : "";
        var ws_data = [];
        var data = await postApWhtReconExpSp(period, id);

        if (data) {
          data.forEach((item) => {
            ws_data.push([Object.values(item).join("|")]);
          });
          /* make the worksheet */
          //var ws_data = [["1"],[2]];
          var ws = XLSX.utils.aoa_to_sheet(ws_data);
          /* add to workbook */
          var wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
          XLSX.writeFile(
            wb,
            // selectedOption.value === "3"
            //   ? `ภงด_3_${ToMySqlDate(new Date())}.txt`
            //   : `ภงด_53_${ToMySqlDate(new Date())}.txt`
            `AP_WhtVatReconRpt.txt`
          );
        } else {
          SnackbarUtils.error("No data");
        }
      },
      disabled: listId?.length < 1,
      hide: GetSettingCountry().hideWhtReconBtnPrint,
    },
    // { name: "Export", fnc: () => setOpenDialog((state) => ({ ...state, export: true })), disabled: Data?.length < 1 },
  ];

  const fetchWhtYearLookup = async () => {
    var arr = await getWhtYearList();
    setListOfWhtYear(arr);
  };

  const fetchVendorLookup = async () => {
    const { Data } = await getApVendorList();
    setLookupList((state) => ({
      ...state,
      vendorList: Data,
    }));
  };

  const fetchWhtTypeLookup = async () => {
    const { Data } = await getApWhtTypeSearchList();
    setLookupList((state) => ({
      ...state,
      whtTypeList: Data,
    }));
  };

  const fetchWhtServiceLookup = async () => {
    const { Data } = await getApWhtServiceSearchList();
    setLookupList((state) => ({
      ...state,
      whtServiceList: Data,
    }));
  };

  useEffect(() => {
    fetchWhtYearLookup();
    fetchVendorLookup();
    fetchWhtTypeLookup();
    fetchWhtServiceLookup();
  }, [Data]);

  const fetchSearchList = async (filter, mounted) => {
    //update apWhtRecon
    await importWhtYearList(filter);

    const response = await getWhtReconcileByYearMonth(filter);
    if (response) {
      var newResponse;
      if (filter.whtForm !== "All") {
        newResponse = response.filter((x) => x.WhtTypeCode === filter.whtForm);
      } else {
        newResponse = response;
      }
      setData(newResponse);
    } else {
      setData([]);
    }
    if (mounted) {
      setLoading(false);
    }
  };

  useEffect(() => {
    let mounted = true;
    fetchSearchList(filter, mounted);
    return function cleanup() {
      mounted = false;
    };
  }, [filter]);

  const columns = [
    {
      title: " ",
      field: "Id",
      sorting: true,
      render: (rowData) => {
        return (
          <div style={{ display: "flex" }}>
            <Tooltip title={`Edit ${rowData.Id}`}>
              <IconButton
                size="small"
                color="primary"
                style={{ cursor: "pointer" }}
                onClick={() => UpdateRow(rowData.Id)}
              >
                <Icon>edit</Icon>
              </IconButton>
            </Tooltip>
            {rowData.Source !== "Exported" && (
              <Tooltip title={`Delete ${rowData.Id}`}>
                <IconButton
                  size="small"
                  color="primary"
                  style={{ cursor: "pointer", marginLeft: 10 }}
                  onClick={async () => {
                    let msg = translate("ra.question.confirmDel");
                    SnackbarUtils.delConfirm(msg, async function () {
                      const { Code, InternalMessage, UserMessage } = await delWhtReconcileDetail(rowData.Id);
                      if (Code === 0) {
                        SnackbarUtils.success(UserMessage, function () {
                          fetchSearchList(filter);
                        });
                      } else {
                        SnackbarUtils.warning(InternalMessage, function () {
                          fetchSearchList(filter);
                        });
                      }
                    });
                  }}
                >
                  <Icon>delete</Icon>
                </IconButton>
              </Tooltip>
            )}
          </div>
        );
      },
    },
    { title: "Source", field: "Source", sorting: false },
    {
      title: "Vendor",
      field: "VnCode",
      sorting: true,
      cellStyle: {
        width: 300,
      },
    },
    {
      title: "Title",
      field: "PreName",
      sorting: true,
      cellStyle: {
        width: 100,
      },
    },
    {
      title: "Payee",
      field: "PayeeName",
      sorting: true,
      cellStyle: {
        width: 300,
      },
    },
    {
      title: "Address",
      field: "Address",
      sorting: true,
      cellStyle: {
        width: 300,
      },
    },
    { title: "TAX ID.", field: "TaxId", sorting: true },
    { title: "Branch No.", field: "BranchNo", sorting: true },

    {
      title: "Date",
      field: "PayDate",
      sorting: true,
      render: (rowData) => {
        let value = rowData.PayDate;
        if (!rowData.PayDate) {
          return null;
        }
        return DateToString(value ?? new Date());
      },
    },
    { title: "WHT. No", field: "WhtNo", sorting: true },
    { title: "WHT. Form", field: "WhtTypeCode", sorting: true },
    { title: "WHT. Desc", field: "WhtDesc", sorting: true },
    { title: "WHT. Rate %", field: "WhtRate", sorting: true },
    {
      title: "Payment Amount",
      field: "Amount",
      sorting: true,
      type: "numeric",
      render: (rowData) => NumberFormat(rowData.Amount),
    },
    {
      title: "Tax",
      field: "TaxAmt",
      sorting: true,
      type: "numeric",
      render: (rowData) => NumberFormat(rowData.TaxAmt),
    },
    {
      title: "WHT. Ref.",
      field: "Remark1",
      sorting: false,
    },
  ];

  const options = {
    draggable: false,
    headerStyle: {
      backgroundColor: theme.palette.primary.main,
      color: "#FFF",
    },
    padding: "dense",
    paging: true,
    pageSize: 15,
    pageSizeOptions: [15, 50, 100],
    selection: true,
    selectionProps: () => ({
      color: "primary",
    }),
    rowStyle: (item) => {
      if (item.tableData.id % 2) {
        return { backgroundColor: "#f2f2f2" };
      }
    },
  };

  const DialogTitle = (props) => {
    const { children, onClose, ...other } = props;
    return (
      <MuiDialogTitle disableTypography className={classes.rootTitle} {...other}>
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
          <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
            <Icon>close</Icon>
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
  };

  const handleCancel = () => {
    onClose();
  };

  const CustomFilterList = (props) => {
    return (
      <>
        <MTableToolbar {...props} />
        <Box display="flex" style={{ marginTop: props.selectedRows.length > 0 ? 0 : -50 }}>
          <Box p={1}>
            <FormControl variant="outlined" fullWidth>
              <InputLabel id="label">Month</InputLabel>
              <Select
                labelId="label"
                variant="outlined"
                margin="dense"
                label="Month"
                style={{ width: 160 }}
                value={filter.month}
                onChange={(e) => {
                  setFilter((state) => ({
                    ...state,
                    month: e.target.value,
                  }));
                }}
              >
                {listOfMonth
                  ? listOfMonth.map((item, idx) => (
                      <MenuItem key={idx} value={item}>
                        {item}
                      </MenuItem>
                    ))
                  : ""}
              </Select>
            </FormControl>
          </Box>
          {listOfWhtYear && (
            <Box p={1}>
              <FormControl variant="outlined" fullWidth>
                <InputLabel id="label">Year</InputLabel>
                <Select
                  labelId="label"
                  variant="outlined"
                  margin="dense"
                  label="Year"
                  style={{ width: 160 }}
                  value={filter.year}
                  onChange={(e) => {
                    setFilter((state) => ({
                      ...state,
                      year: e.target.value,
                    }));
                  }}
                >
                  {listOfWhtYear
                    ? listOfWhtYear.map((item, idx) => (
                        <MenuItem key={idx} value={item}>
                          {item}
                        </MenuItem>
                      ))
                    : ""}
                </Select>
              </FormControl>
            </Box>
          )}
          <Box p={1}>
            <FormControl variant="outlined" fullWidth>
              <InputLabel id="labelwht">{translate("ra.field.WHT. Form")}</InputLabel>
              <Select
                labelId="labelwht"
                variant="outlined"
                margin="dense"
                label={translate("ra.field.WHT. Form")}
                style={{ width: 160 }}
                value={filter.whtForm}
                onChange={(e) => {
                  setFilter((state) => ({
                    ...state,
                    whtForm: e.target.value,
                  }));
                }}
              >
                <MenuItem value={"All"}>{translate("ra.field.All")}</MenuItem>
                {lookupList.whtTypeList.map((i) => (
                  <MenuItem value={i.Description}>{i.Description}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </Box>
      </>
    );
  };

  const CustomHeader = (props) => {
    return (
      <>
        <TableHead>
          <TableRow>
            <TableCell align="center" colSpan={1}>
              <IconButton size={"small"} onClick={AddNewRow} style={{ marginLeft: 6 }}>
                {isLoadingBtn ? <CircularProgress size={20} /> : <Icon>add</Icon>}
              </IconButton>
            </TableCell>
            <TableCell align="right" colSpan={10}></TableCell>
          </TableRow>
        </TableHead>
        <MTableHeader {...props} />
      </>
    );
  };

  const AddNewRow = async () => {
    setLoadingBtn(true);
    const p = {
      period: Data.PayDate ? `${getYear(Data.PayDate)}-${getMonth(Data.PayDate)}` : `${filter.year}-${filter.month}`,
    };
    const whtAuto = await callStoreReport("spGetApWhtMaxWhtNo", p);
    if (whtAuto?.length > 0) {
      let whtAuto1 = (whtAuto[0].MaxId + 1).toString();
      let padLeftWhtAuto1 = whtAuto1.length > 6 ? whtAuto1 : whtAuto1.padStart(6, "0");
      let year = getYear(new Date()).toString();
      let pyhRefNoAuto = `WR${year.substring(year.length - 2, year.length)}${padLeftWhtAuto1}`;
      setInitNewRow((state) => ({
        ...state,
        PyhSeq: pyhRefNoAuto ?? "",
      }));
    }
    setEditIndex("");
    setShowAdd(true);
    setCheckSource(false);
    setLoadingBtn(false);
  };

  const UpdateRow = (index) => {
    setEditIndex(index);
    setShowAdd(true);
    let selectedItem = Data.find((item) => item.Id === index);
    setCheckSource(selectedItem.Source === "Exported");
  };

  const UpdateFromPopup = (currentField, m, data) => {
    m.trigger();
    let amt = ToNumber(data["Amount"]);
    let whtrate = ToNumber(data["WhtRate"]);
    if (currentField === "WhtRate") {
      let taxAmt = amt * (whtrate / 100);
      m.setValue("TaxAmt", NumberFormat(taxAmt));
    }
    if (currentField === "Amount") {
      let taxAmt = amt * (whtrate / 100);
      m.setValue("TaxAmt", NumberFormat(taxAmt, "unit"));
    }
  };

  const SaveFromPopup = async (arr, row) => {
    row.PeriodName = `${filter.year}-${filter.month}`;
    delete row.Dim;
    if (editIndex !== "") {
      //update
      const { Code, InternalMessage, UserMessage } = await updateWhtReconcileDetail(row);
      if (Code === 0) {
        SnackbarUtils.success(UserMessage, function () {
          setShowAdd(false);
          fetchSearchList(filter);
        });
      } else {
        SnackbarUtils.confirm(
          InternalMessage ?? UserMessage,
          function () {
            return false;
          },
          async function () {
            let newParam2 = {
              ...row,
              forceUpdate: true,
            };
            const { Code, UserMessage } = await updateWhtReconcileDetail(newParam2);
            if (Code === 0) {
              SnackbarUtils.success(UserMessage, function () {
                setShowAdd(false);
                fetchSearchList(filter);
              });
            }
          }
        );
      }
    } else {
      // row.WhtTypeCode = row.WhtTypeDesc ?? "";
      // row.WhtDesc = row.WhtCateDesc ?? "";
      //create
      let newParam = {
        ...initNewRow,
        ...row,
      };
      const { Code, InternalMessage, UserMessage } = await createWhtReconcileDetail(newParam);
      if (Code === 0) {
        SnackbarUtils.success(UserMessage, function () {
          setShowAdd(false);
          fetchSearchList(filter);
        });
      } else {
        SnackbarUtils.confirm(
          InternalMessage ?? UserMessage,
          function () {
            return false;
          },
          async function () {
            let newParam2 = {
              ...initNewRow,
              ...row,
              forceUpdate: true,
            };
            const { Code, UserMessage } = await createWhtReconcileDetail(newParam2);
            if (Code === 0) {
              SnackbarUtils.success(UserMessage, function () {
                setShowAdd(false);
                fetchSearchList(filter);
              });
            }
          }
        );
      }
    }
  };

  const CancelFromPopup = () => {
    setShowAdd(false);
  };

  const formFieldsDetail = [
    {
      size: 3,
      field: (
        <TextFieldInForm
          label={"Payment Ref. No."}
          name="PyhSeq"
          variant="outlined"
          margin="dense"
          rule={{
            required: {
              value: true,
              message: "* Required",
            },
            maxLength: {
              value: 30,
              message: "maximum length is 30",
            },
          }}
          disabled={checkSource}
        />
      ),
    },
    {
      size: 3,
      field: (
        <MuiAutosuggest
          label={`${GetSettingCountry().countryCode === "PH" ? "*" : ""} ${translate("ra.field.Vendor")}`}
          name="VnCode"
          optKey="VnCode"
          optDesc="VnName"
          options={lookupList["vendorList"]}
          useFncUpdate={true}
          fncUpdate={(value, methods) => {
            methods.setValue("PayeeName", value.VnPayee);
            methods.setValue("InvhCredit", value.VnTerm);
            methods.setValue("TaxProfileCode", value.TaxProfileCode1);
            methods.setValue("TaxId", value.VnTaxNo);
            methods.setValue("BranchNo", value.BranchNo);
            const mergeVnAdd = `${value["VnAdd1"]} ${value["VnAdd2"]} ${value["VnAdd3"]}`;
            methods.setValue("Address", mergeVnAdd);
          }}
          style={{ marginTop: -18 }}
          disabled={checkSource}
          rule={{
            required: {
              value: GetSettingCountry().countryCode === "PH",
              message: "* Required",
            },
          }}
        />
      ),
    },
    {
      size: 3,
      field: (
        <TextFieldInForm
          label={`${GetSettingCountry().countryCode !== "PH" ? "*" : ""} ${translate("ra.field.Payee")}`}
          name="PayeeName"
          variant="outlined"
          margin="dense"
          rule={{
            required: {
              value: GetSettingCountry().countryCode !== "PH",
              message: "* Required",
            },
            maxLength: {
              value: 255,
              message: "maximum length is 255",
            },
          }}
          disabled={GetSettingCountry().countryCode === "PH"}
        />
      ),
    },
    {
      size: 3,
      field: (
        <TextFieldInForm
          label={translate("ra.field.Title")}
          name="PreName"
          variant="outlined"
          margin="dense"
          rule={{
            maxLength: {
              value: 50,
              message: "maximum length is 50",
            },
          }}
        />
      ),
    },

    {
      size: 12,
      field: (
        <TextFieldInForm
          label={`${GetSettingCountry().countryCode !== "PH" ? "*" : ""} ${translate("ra.field.Address")}`}
          name="Address"
          variant="outlined"
          margin="dense"
          rule={{
            required: {
              value: GetSettingCountry().countryCode !== "PH",
              message: "* Required",
            },
            maxLength: {
              value: 255,
              message: "maximum length is 255",
            },
          }}
          disabled={GetSettingCountry().countryCode === "PH"}
        />
      ),
    },
    {
      size: 3,
      field: (
        <TextFieldInForm
          label={`${GetSettingCountry().countryCode !== "PH" ? "*" : ""} ${translate("ra.field.TAX ID.")}`}
          name="TaxId"
          variant="outlined"
          margin="dense"
          rule={{
            required: {
              value: GetSettingCountry().countryCode !== "PH",
              message: "* Required",
            },
            maxLength: {
              value: 30,
              message: "maximum length is 30",
            },
          }}
          disabled={GetSettingCountry().countryCode === "PH"}
        />
      ),
    },
    {
      size: 3,
      field: (
        <TextFieldInForm
          label={`${GetSettingCountry().countryCode !== "PH" ? "*" : ""} ${translate("ra.field.Branch No.")}`}
          name="BranchNo"
          variant="outlined"
          margin="dense"
          rule={{
            required: {
              value: GetSettingCountry().countryCode !== "PH",
              message: "* Required",
            },
            maxLength: {
              value: 20,
              message: "maximum length is 20",
            },
          }}
          disabled={GetSettingCountry().countryCode === "PH"}
        />
      ),
    },
    {
      size: 3,
      field: (
        <DateInForm
          label={translate("ra.field.Withholding Tax Date")}
          name="PayDate"
          style={{ marginTop: -14 }}
          minDate={new Date(`${filter.year}-${filter.month}-01`)}
          maxDate={lastDayOfMonth(new Date(filter.year, Number(filter.month) - 1, 1))}
          minDateMessage={"Date must be more than close period"}
          maxDateMessage={"Date should not allow greater than tax period selected"}
          // rule={{
          //   required: {
          //     value: true,
          //     message: "* Required",
          //   },
          // }}
          disabled={checkSource}
          rule={{
            required: {
              value: true,
              message: "* Required",
            },
          }}
          useHelperText
        />
      ),
    },
    {
      size: 3,
      field: (
        <TextFieldInForm
          label={translate("ra.field.WHT. No")}
          name="WhtNo"
          variant="outlined"
          margin="dense"
          rule={{
            maxLength: {
              value: 30,
              message: "maximum length is 30",
            },
          }}
          //disabled={checkSource}
        />
      ),
    },

    {
      size: 3,
      field: (
        <MuiAutosuggest
          label={"*" + translate("ra.field.WHT. Form")}
          name="WhtTypeCode"
          optKey="Description"
          //optDesc="Description"
          options={lookupList["whtTypeList"]}
          updateOtherField={[{ key: "WhtTypeDesc", optKey: "Description" }]}
          rule={{
            required: {
              value: true,
              message: "* Required",
            },
          }}
          disabled={checkSource}
        />
      ),
    },
    {
      size: 3,
      field:
        GetSettingCountry().countryCode === "TH" ? (
          <MuiAutosuggest
            label={"*" + translate("ra.field.WHT. Service Type")}
            name="WhtDesc"
            optKey="Description"
            // optDesc="WhtCode"
            options={lookupList["whtServiceList"]}
            updateOtherField={[
              //{ key: "WhtCateDesc", optKey: "Description" },
              { key: "WhtRate", optKey: "WhtRate" },
            ]}
            rule={{
              required: {
                value: true,
                message: "* Required",
              },
            }}
            disabled={checkSource}
          />
        ) : (
          <MuiAutosuggest
            label={"*" + translate("ra.field.WHT. Service Type")}
            name="WhtDesc"
            optKey="WhtCode"
            optDesc="Description"
            options={lookupList["whtServiceList"]}
            updateOtherField={[{ key: "WhtRate", optKey: "WhtRate" }]}
            rule={{
              required: {
                value: true,
                message: "* Required",
              },
            }}
            disabledListBox
            disabled={checkSource}
          />
        ),
    },
    {
      size: 3,
      field: (
        <NumberFormatInForm
          label={"*" + translate("ra.field.WHT. Rate %")}
          name="WhtRate"
          rule={{
            required: {
              value: true,
              message: "* Required",
            },
            min: {
              value: 0.000001,
              message: "* Required",
            },
          }}
          disabled={checkSource}
          decimal={SettingSystem.BaseQtyDecimal}
          decimalSep={SettingSystem.DecimalSeparator}
          thousandSep={SettingSystem.ThousandSeparator}
        />
      ),
    },
    {
      size: 3,
      field: (
        <NumberFormatInForm
          label={"*" + translate("ra.field.Payment Amount")}
          name="Amount"
          rule={{
            required: {
              value: true,
              message: "* Required",
            },
            min: {
              value: 0.000001,
              message: "* Required",
            },
          }}
          disabled={checkSource}
          decimal={SettingSystem.BaseQtyDecimal}
          decimalSep={SettingSystem.DecimalSeparator}
          thousandSep={SettingSystem.ThousandSeparator}
        />
      ),
    },
    {
      size: 3,
      field: (
        <SelectInForm
          label={translate("ra.field.WHT. Condition")}
          name="Remark1"
          options={WithholdingTaxRefOption}
          keyInDesc
          style={{ "&.MuiInputLabel-shrink": { transform: "translate(14px, -2px) scale(0.75)" } }}
        />
      ),
    },

    {
      size: 6,
      field: <div></div>,
      implementation: "css",
      smDown: true,
      component: { Hidden },
    },
    {
      size: 3,
      field: (
        <NumberFormatInForm
          label={"*" + translate("ra.field.WHT. Amount")}
          name="TaxAmt"
          disabled={checkSource}
          rule={{
            required: {
              value: true,
              message: "* Required",
            },
            min: {
              value: 0.000001,
              message: "* Required",
            },
          }}
          decimal={SettingSystem.BaseQtyDecimal}
          decimalSep={SettingSystem.DecimalSeparator}
          thousandSep={SettingSystem.ThousandSeparator}
        />
      ),
    },
  ];

  const dialogOption = [
    // {
    //   value: "2",
    //   desc: "ภ.ง.ด 2",
    // },
    {
      value: "3",
      desc: "ภ.ง.ด 3",
    },
    {
      value: "53",
      desc: "ภ.ง.ด 53",
    },
  ];

  const onCloseDialogForm = async (arr) => {
    if (arr) {
      let period = `${filter.year}-${filter.month}`;
      let id = listId.length > 0 ? listId.join() : "";
      let page = arr
        .filter((x) => x.value === true)
        .map((i) => i.index)
        .toString();
      let param = [
        { Name: "Period", Value: period },
        { Name: "SeqId", Value: id },
        { Name: "Page", Value: page },
      ];
      setLoadingBtn(true);
      let status = await showReportByName("AP_WhtVatRecon", param);
      if (status) {
        setLoadingBtn(false);
      }
    }
    setOpenDialog((state) => ({ ...state, form: false }));
  };

  const onCloseDialogReport = async (selectedOption) => {
    if (selectedOption) {
      let period = `${filter.year}-${filter.month}`;
      let id = "";
      //let page = "";
      let param = [
        { Name: "Period", Value: period },
        { Name: "SeqId", Value: id },
        { Name: "TaxType", Value: selectedOption.value },
        //{ Name: "Page", Value: page },
      ];
      //let param = `'${period}','${id}','${selectedOption.value}','${page}'`;
      setLoadingBtn(true);
      let status = await showReportByName("AP_WhtVatReconRpt", param);
      if (status) {
        setLoadingBtn(false);
      }
    }
    setOpenDialog((state) => ({ ...state, report: false }));
  };

  const onCloseDialogExport = async (selectedOption) => {
    if (selectedOption) {
      let period = `${filter.year}-${filter.month}`;
      let id = listId.length > 0 ? listId.join() : "";
      var ws_data = [];
      var data = await postApWhtReconExpSp(period, id, selectedOption.value);

      if (data) {
        data.forEach((item) => {
          ws_data.push([Object.values(item).join("|")]);
        });
        /* make the worksheet */
        //var ws_data = [["1"],[2]];
        var ws = XLSX.utils.aoa_to_sheet(ws_data);
        /* add to workbook */
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
        XLSX.writeFile(
          wb,
          selectedOption.value === "3"
            ? `ภงด_3_${ToMySqlDate(new Date())}.txt`
            : `ภงด_53_${ToMySqlDate(new Date())}.txt`
        );
      } else {
        SnackbarUtils.error("No data");
      }
    }

    setOpenDialog((state) => ({ ...state, export: false }));
  };

  return (
    <Dialog fullWidth maxWidth="xl" aria-labelledby="confirmation-dialog-title" open={open}>
      <DialogTitle id="customized-dialog-title" onClose={handleCancel}>
        {props.title}
      </DialogTitle>
      <DialogContent dividers>
        <ActionMenu justifyContent="flex-start" menuControl={menuControlProp} />
        <MeterialtableTranslate
          title=""
          data={Data}
          columns={columns}
          options={options}
          onSelectionChange={(rows) => setListId(rows.map((i) => i.Id))}
          isLoading={isLoading}
          components={{
            Header: CustomHeader,
            Toolbar: CustomFilterList,
          }}
        />

        {showAdd && (
          <PopupTable
            initialValues={editIndex !== "" ? Data.find((i) => i.Id === editIndex) : initNewRow}
            formFields={formFieldsDetail}
            update={UpdateFromPopup}
            open={showAdd}
            save={(row) => SaveFromPopup(Data, row)}
            cancel={CancelFromPopup}
            maxWidth={"md"}
          ></PopupTable>
        )}
        {openDialog.form && (
          <DialogPrintItem open={openDialog.form} onClose={onCloseDialogForm} isLoading={isLoadingBtn} />
        )}

        {openDialog.report && (
          <DialogOptions
            open={openDialog.report}
            onClose={onCloseDialogReport}
            options={dialogOption}
            headerText="Select Type"
            isLoading={isLoadingBtn}
          />
        )}

        {openDialog.export && (
          <DialogOptions
            open={openDialog.export}
            onClose={onCloseDialogExport}
            options={dialogOption.filter((x) => x.value !== "1")}
            headerText="Select Type"
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default DialogWhtRec;
